import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { xlsxExport } from "../../../utils/xlsxExport";
import Table from "../../../components/coreUiTable/Table";
import DataDisplay from "../../../components/dataDisplay/dataDisplay";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { api } from "./api";
import { useTableData } from "../hooks/useTableData";

export const UserActivityModule = () => {
  let {
    loading,
    tableInfo: { data, colHeaders } = {},
    headerInfo = [],
    filteredData,
    onFilteredItemsChange
  } = useTableData({
    endpoint: api.getList
  });

  if (loading) return <LoadingAnimation />;

  return data && data.length > 0 ? (
    <div id="user_activity_table">
      <div className="data-points">
        {headerInfo.map((dataPoint) => (
          <DataDisplay key={dataPoint[0]} label={dataPoint[0]} value={dataPoint[1]} />
        ))}
      </div>
      <Table
        table={{ colHeaders, data }}
        title=" "
        sorter
        itemsPerPage={15}
        showCount
        onFilteredItemsChange={onFilteredItemsChange}
        overTableSlots={
          <div className="content_download">
            {filteredData.length > 0 ? (
              <>
                <a
                  title="Download as Excel"
                  onClick={() => {
                    xlsxExport({
                      data: filteredData,
                      headers: colHeaders,
                      fileName: "user-activity",
                      dataStructure: "jts"
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} /> Download as Excel
                </a>
                <a
                  title="Download as CSV"
                  onClick={() => {
                    xlsxExport({
                      data: filteredData,
                      headers: colHeaders,
                      fileName: "user-activity",
                      dataStructure: "jts",
                      fileType: "csv"
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} /> Download as CSV
                </a>
              </>
            ) : (
              <>
                <span disabled>
                  <FontAwesomeIcon icon={faDownload} /> Download as Excel
                </span>
                <span disabled>
                  <FontAwesomeIcon icon={faDownload} /> Download as CSV
                </span>
              </>
            )}
          </div>
        }
      />
    </div>
  ) : (
    <div className="error">No data available</div>
  );
};
